import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import analytics from '../services/analytics';
import auth from '../services/auth';
import './AnalyticsPage.css';

const AnalyticsPage = () => {
    const [summary, setSummary] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (!auth.isAuthenticated()) {
            navigate('/admin/login');
            return;
        }
        
        fetchAnalytics();
    }, [navigate]);

    const fetchAnalytics = async () => {
        try {
            const data = await analytics.getSummary();
            setSummary(data);
        } catch (error) {
            setError('Failed to load analytics');
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <div className="analytics-container">Loading...</div>;
    if (error) return <div className="analytics-container error">{error}</div>;

    return (
        <div className="analytics-container">
            <header className="analytics-header">
                <h1><Link to="/">Sercihan's</Link></h1>
            </header>
            
            <div className="analytics-content">
                <div className="analytics-toolbar">
                    <h2>Analytics</h2>
                    <button
                        onClick={() => navigate('/admin/dashboard')}
                        className="back-button"
                    >
                        Back to Dashboard
                    </button>
                </div>

                <div className="stats-grid">
                    <div className="stat-card">
                        <div className="stat-value">{summary.total_views}</div>
                        <div className="stat-label">Total Page Views</div>
                    </div>
                    <div className="stat-card">
                        <div className="stat-value">{summary.unique_visitors}</div>
                        <div className="stat-label">Unique Visitors</div>
                    </div>
                </div>

                <div className="analytics-section">
                    <h3>Top Pages</h3>
                    {summary.top_pages && summary.top_pages.length > 0 ? (
                        <div className="table-container">
                            {summary.top_pages.map((page, index) => (
                                <div key={index} className="table-row">
                                    <div className="table-cell path">{page.path}</div>
                                    <div className="table-cell views">{page.views} views</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-data">No data yet</div>
                    )}
                </div>

                <div className="analytics-section">
                    <h3>Top Countries</h3>
                    {summary.top_countries && summary.top_countries.length > 0 ? (
                        <div className="table-container">
                            {summary.top_countries.map((country, index) => (
                                <div key={index} className="table-row">
                                    <div className="table-cell country">{country.country}</div>
                                    <div className="table-cell views">{country.views} views</div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-data">No data yet</div>
                    )}
                </div>

                <div className="analytics-section">
                    <h3>Recent Views</h3>
                    {summary.recent_views && summary.recent_views.length > 0 ? (
                        <div className="table-container">
                            {summary.recent_views.slice(0, 20).map((view) => (
                                <div key={view.id} className="table-row">
                                    <div className="table-cell path">{view.path}</div>
                                    <div className="table-cell country">{view.country || 'Unknown'}</div>
                                    <div className="table-cell date">
                                        {new Date(view.created_at).toLocaleString()}
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <div className="no-data">No data yet</div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AnalyticsPage;
